<script setup lang="ts">

import { usePQAStore } from '@/stores/PQAStore.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import FormSelect from '@/components/Elements/Forms/FormSelect.vue'
import Backend from '@/models/backend.ts'
import { computed, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const pqaStore = usePQAStore()
const gameStore = useGameStore()

const playerSettlePQA = ref(0)

const pqaOptions = computed(() =>
  [...pqaStore.queues.values()].map((pqa) => ({ value: pqa.id, label: pqa.name }))
)

const selectAndSubmit = (val: string | number) => {
  playerSettlePQA.value = Number(val)
  setPQA()
}

const setPQA = () => {
  const backend = new Backend()
  backend.setPlayerSettlePQA(playerSettlePQA.value).then(() => {
    gameStore.modalType=''
  })
}

onMounted(() => {
  playerSettlePQA.value = gameStore.player?.settlePQA ?? 0
})


</script>

<template>
  <div class="text-metal-300">
    <div class="pb-2 ">{{ t('government.cabinet.autoAssign.settleQueue') }}</div>
    <div>
      <FormSelect
        :modelValue="playerSettlePQA"
        @update:modelValue="selectAndSubmit"
        :options="pqaOptions"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>